import React from "react";
import image from "../background.jpg";

export default function Home() {
    return (
        <main className="home-root">
            <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600&family=Sora:wght@700;800&display=swap');

        .home-root {
          min-height: 100vh;
          background-color: #080e1c;
          font-family: 'Inter', system-ui, sans-serif;
          position: relative;
          overflow: hidden;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        /* Background image with dark overlay */
        .home-bg {
          position: fixed;
          inset: 0;
          z-index: 0;
        }

        .home-bg img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          filter: brightness(0.15) saturate(0.5);
        }

        /* Radial glow overlays — same as About */
        .home-bg::after {
          content: '';
          position: absolute;
          inset: 0;
          background:
            radial-gradient(ellipse 70% 60% at 15% 20%, rgba(99,102,241,0.18) 0%, transparent 60%),
            radial-gradient(ellipse 50% 40% at 85% 75%, rgba(56,189,248,0.10) 0%, transparent 55%);
        }

        /* Main content */
        .home-content {
          position: relative;
          z-index: 1;
          max-width: 780px;
          margin: 0 auto;
          padding: 2rem;
          text-align: center;
        }

        .home-eyebrow {
          display: inline-flex;
          align-items: center;
          gap: 0.5rem;
          background: rgba(99,102,241,0.12);
          border: 1px solid rgba(99,102,241,0.3);
          border-radius: 100px;
          padding: 0.4rem 1rem;
          font-size: 0.75rem;
          font-weight: 600;
          color: #a5b4fc;
          letter-spacing: 0.08em;
          text-transform: uppercase;
          margin-bottom: 2rem;
        }

        .home-eyebrow-dot {
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background: #4ade80;
          animation: pulse 2s ease infinite;
          flex-shrink: 0;
        }

        @keyframes pulse {
          0%, 100% { opacity: 1; transform: scale(1); }
          50%       { opacity: 0.5; transform: scale(0.8); }
        }

        .home-heading {
          font-family: 'Sora', system-ui, sans-serif;
          font-size: clamp(2.8rem, 7vw, 5rem);
          font-weight: 800;
          line-height: 1.08;
          letter-spacing: -0.03em;
          color: #f0f4ff;
          margin-bottom: 1.5rem;
        }

        .home-heading span {
          background: linear-gradient(90deg, #818cf8, #38bdf8);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }

        .home-sub {
          font-size: 1.1rem;
          color: #64748b;
          line-height: 1.7;
          max-width: 660px;
          margin: 0 auto 2.5rem;
        }

        .home-sub strong {
          color: #94a3b8;
          font-weight: 500;
        }

        .home-sub p {
          margin: 0 0 0.75rem 0;
        }

        .home-sub p:last-child {
          margin-bottom: 0;
          color: #6366f1;
          font-weight: 500;
        }

        /* Tech pills */
        .home-pills {
          display: flex;
          flex-wrap: wrap;
          gap: 0.5rem;
          justify-content: center;
          margin-bottom: 3rem;
        }

        .home-pill {
          background: rgba(99,102,241,0.1);
          border: 1px solid rgba(99,102,241,0.2);
          color: #a5b4fc;
          font-size: 0.72rem;
          font-weight: 500;
          padding: 0.35rem 0.75rem;
          border-radius: 6px;
          letter-spacing: 0.02em;
        }

        /* CTA buttons */
        .home-ctas {
          display: flex;
          gap: 1rem;
          justify-content: center;
          flex-wrap: wrap;
        }

        .btn-primary {
          display: inline-flex;
          align-items: center;
          gap: 0.5rem;
          background: linear-gradient(135deg, #6366f1, #818cf8);
          color: #fff;
          font-weight: 600;
          font-size: 0.9rem;
          padding: 0.85rem 1.75rem;
          border-radius: 10px;
          text-decoration: none;
          transition: opacity 0.2s, transform 0.2s;
          box-shadow: 0 4px 24px rgba(99,102,241,0.4);
        }

        .btn-primary:hover {
          opacity: 0.88;
          transform: translateY(-2px);
        }

        .btn-secondary {
          display: inline-flex;
          align-items: center;
          gap: 0.5rem;
          background: transparent;
          color: #94a3b8;
          font-weight: 500;
          font-size: 0.9rem;
          padding: 0.85rem 1.5rem;
          border-radius: 10px;
          text-decoration: none;
          border: 1px solid rgba(148,163,184,0.2);
          transition: color 0.2s, border-color 0.2s, transform 0.2s;
        }

        .btn-secondary:hover {
          color: #f0f4ff;
          border-color: rgba(148,163,184,0.45);
          transform: translateY(-2px);
        }

        /* Scroll hint */
        .scroll-hint {
          position: absolute;
          bottom: 2rem;
          left: 50%;
          transform: translateX(-50%);
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 0.4rem;
          color: #334155;
          font-size: 0.7rem;
          letter-spacing: 0.1em;
          text-transform: uppercase;
        }

        .scroll-arrow {
          width: 1px;
          height: 40px;
          background: linear-gradient(to bottom, rgba(99,102,241,0.6), transparent);
          animation: scrollDown 1.8s ease infinite;
        }

        @keyframes scrollDown {
          0%   { opacity: 0; transform: scaleY(0); transform-origin: top; }
          50%  { opacity: 1; }
          100% { opacity: 0; transform: scaleY(1); transform-origin: top; }
        }

        @media (max-width: 640px) {
          .home-heading { font-size: 2.4rem; }
          .home-sub     { font-size: 0.95rem; }
        }
      `}</style>

            {/* Background */}
            <div className="home-bg">
                <img src={image} alt="" aria-hidden="true" />
            </div>

            {/* Hero content */}
            <div className="home-content">

                <div className="home-eyebrow">
                    <span className="home-eyebrow-dot" />
                    Open to opportunities · Melbourne, AU
                </div>

                <h1 className="home-heading">
                    Rashi Agrawal
                </h1>
                <p className="home-tagline">Developer · Builder · Solution Finder</p>

                <div className="home-sub">
                    <p>A software engineer based in Melbourne, though I spend most of my time in terminals and pull requests.</p>
                    <p>I've spent 3+ years building production systems that handle real users, real orders, and real consequences — the kind of software that quietly keeps a business running while nobody's paying attention to it.</p>
                    <p>I'm comfortable across the full stack, pick up new technologies faster than I finish my coffee, and genuinely enjoy the kind of problems that don't have an obvious answer.</p>
                    <p>There's more to the story — and I think it's worth reading.</p>
                </div>

                <div className="home-ctas">
                    <a href="/portfolio" className="btn-primary">
                        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                            <rect x="2" y="3" width="20" height="14" rx="2" /><line x1="8" y1="21" x2="16" y2="21" /><line x1="12" y1="17" x2="12" y2="21" />
                        </svg>
                        View My Work
                    </a>
                    <a href="/about" className="btn-secondary">
                        About Me
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <line x1="5" y1="12" x2="19" y2="12" /><polyline points="12 5 19 12 12 19" />
                        </svg>
                    </a>
                </div>
            </div>

            {/* Scroll indicator */}
            <div className="scroll-hint" aria-hidden="true">
                <div className="scroll-arrow" />
            </div>

        </main>
    );
}